import { useEffect } from 'react';
import { useFlagsmith } from 'flagsmith-react';
import { useDispatch, useSelector } from 'react-redux';
import { setFlagsIdentityLoaded, setFlagsIdentityLoading } from '../../store/actions/featureFlags';

export default function IdentifyFlagsmith(props) {
  const { user } = useSelector((state) => state.role);
  const { identify, isLoading } = useFlagsmith();
  const dispatch = useDispatch();
  const { identityLoading, identity: currentIdentity } = useSelector((state) => state.featureFlags);

  useEffect(() => {
    (async () => {
      if (isLoading || identityLoading) return;
      if (!user) {
        return dispatch(setFlagsIdentityLoaded(null));
      }

      if (user.id === currentIdentity) {
        return;
      }

      dispatch(setFlagsIdentityLoading());

      const { id, email, role } = user;
      await identify(id, { email, role });

      dispatch(setFlagsIdentityLoaded(user.id));
    })();
  }, [isLoading, identify, user, dispatch, currentIdentity, identityLoading]);

  return props.children;
}
